import type { ReactNode } from 'react'
import { CORES_SEMANTICAS } from '../../dominio/didatico/tokens'
import { geometriaDeMembro, type FormaDeMembro } from './corpoHumano'

interface SegmentoProps {
  comprimento: number
  /** raio máximo do segmento; a silhueta afina a partir dele (ver `corpoHumano`) */
  raio: number
  /** coxa e perna têm panturrilha, braço e antebraço afinam no punho */
  forma: FormaDeMembro
  cor?: string
  /** abaixo de 1 torna o segmento translúcido (Raio-X da cinemática) */
  opacidade?: number
  /** o pivô fica no topo do segmento, como numa articulação */
  children?: ReactNode
}

/**
 * Segmento de membro com pivô na articulação.
 *
 * O grupo externo é a articulação (posição/rotação ficam no pai); a malha vai
 * do pivô (y = 0) à ponta (y = −comprimento), então rotacionar o pai gira o
 * membro em torno da articulação — e não em torno do meio do osso. A geometria
 * é compartilhada entre os segmentos de mesma dimensão.
 */
export function SegmentoCorporal({ comprimento, raio, forma, cor = CORES_SEMANTICAS.vitimaRoupa, opacidade, children }: SegmentoProps) {
  return (
    <group>
      <mesh>
        <primitive object={geometriaDeMembro(forma, comprimento, raio)} attach="geometry" />
        <meshStandardMaterial
          color={cor}
          roughness={0.7}
          metalness={0.05}
          transparent={opacidade !== undefined && opacidade < 1}
          opacity={opacidade ?? 1}
        />
      </mesh>
      {/* a próxima articulação nasce na ponta do segmento */}
      <group position={[0, -comprimento, 0]}>{children}</group>
    </group>
  )
}
